function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import get from 'lodash/get';
import { AppContext } from 'context';
import { getSlug } from 'helpers/urlTools';
import Avatar from 'components/Avatar';
import Button from 'components/Form/Button';
import Account from 'modules/Account';
import styles from './ActiveClinicMembershipBtn.pcss';
var _React_Component;
class ActiveClinicMembershipBtn extends (_React_Component = React.Component) {
    renderLogo(clinic) {
        const { logo, name } = clinic;
        return /*#__PURE__*/ _jsx(Avatar, {
            avatarImg: logo,
            name: name,
            className: styles.logo,
            imgClassName: styles.logo__img,
            initialsClassName: styles.logo__initials
        });
    }
    renderButtonContent(activeEntity) {
        const clinic = get(activeEntity, 'clinic', {});
        return /*#__PURE__*/ _jsxs("div", {
            className: "row",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-auto pr-0",
                    children: this.renderLogo(clinic)
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col",
                    children: /*#__PURE__*/ _jsx("p", {
                        className: styles.label,
                        children: clinic.name
                    })
                })
            ]
        });
    }
    render() {
        const { activeClinicMembership } = this.props;
        if (!activeClinicMembership) return null;
        const { organizationUID, name } = get(activeClinicMembership, 'clinic', {});
        return /*#__PURE__*/ _jsx(Button, {
            type: "link",
            to: this.context.getUrl('general-population', {
                clinicSlug: getSlug(name),
                organizationUID
            }),
            styleModifier: this.props.styleModifier,
            className: cn(styles.root, this.props.className),
            children: this.renderButtonContent(activeClinicMembership)
        });
    }
}
_define_property(ActiveClinicMembershipBtn, "contextType", AppContext);
_define_property(ActiveClinicMembershipBtn, "propTypes", {
    // Explicit props
    styleModifier: PropTypes.string,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    // Implicit props
    activeClinicMembership: Account.shapes.clinicMembership
});
_define_property(ActiveClinicMembershipBtn, "defaultProps", {
    styleModifier: 'transparent-primary',
    className: 'btn--block btn--filled'
});
const mapStateToProps = (state)=>({
        activeClinicMembership: Account.selectors.activeClinicMembership(state)
    });
const ConnectedActiveClinicMembershipBtn = connect(mapStateToProps)(ActiveClinicMembershipBtn);
export default withStyles(styles)(ConnectedActiveClinicMembershipBtn);
